import React from 'react';
import Navigation from '../../components/Navigation/Navigation';
import ProfilCard from '../../components/ProfilCard/ProfilCard';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import ProfilFooter from '../../components/ProfilCard/ProfilFooter';

const ProfilPage = () => {
    return (
        <div>
            <Navigation />
            <BreadCrumb />
            <ProfilCard />
            <ProfilFooter />
        </div>
    );
};

export default ProfilPage;